if (!customElements.get('product-form')) {

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {

      constructor() {

        super();

        this.form =
          this.querySelector('form');


        if (!this.form) {
          return;
        }


        const variantInput =
          this.form.querySelector(
            '[name=id]'
          );


        if (variantInput) {

          variantInput.disabled =
            false;

        }


        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );


        this.cartNotification =
          document.querySelector(
            'cart-notification'
          );

      }



      /* =====================================================
         GET MAIN PRODUCT QUANTITY
         ===================================================== */

      getMainProductQuantity() {

        /*
          FormData is used because Shopify may associate
          the quantity input with the product form using
          the HTML "form" attribute even when the quantity
          input is visually outside the <form>.
        */

        const temporaryFormData =
          new FormData(
            this.form
          );


        let quantity =
          parseInt(
            temporaryFormData.get(
              'quantity'
            ) || '1',
            10
          );


        if (
          isNaN(quantity) ||
          quantity < 1
        ) {

          quantity = 1;

        }


        return quantity;

      }



      async onSubmitHandler(evt) {

        evt.preventDefault();


        const submitButton =
          this.querySelector(
            '[type="submit"]'
          );


        if (
          !submitButton ||
          submitButton.classList.contains(
            'loading'
          )
        ) {

          return;

        }


        this.handleErrorMessage();


        if (
          this.cartNotification
        ) {

          this.cartNotification
            .setActiveElement(
              document.activeElement
            );

        }


        submitButton.setAttribute(
          'aria-disabled',
          true
        );


        submitButton.classList.add(
          'loading'
        );


        const spinner =
          this.querySelector(
            '.loading-overlay__spinner'
          );


        if (spinner) {

          spinner.classList.remove(
            'hidden'
          );

        }



        try {


          /* =================================================
             GET WHEELCHAIR QUANTITY

             Example:

             Wheelchair Qty 2
             → Accessory Qty 2

             Wheelchair Qty 3
             → Accessory Qty 3
             ================================================= */

          const mainProductQuantity =
            this.getMainProductQuantity();



          /* =================================================
             STEP 1
             FIND SELECTED ACCESSORIES
             ================================================= */

          const accessoryRoot =
            document.querySelector(
              '[data-meos-accessories]'
            );


          const selectedAccessories =
            accessoryRoot

              ? accessoryRoot.querySelectorAll(
                  '.meos-accessory__checkbox:checked:not(:disabled)'
                )

              : [];



          /* =================================================
             STEP 2
             ADD SELECTED ACCESSORIES

             IMPORTANT:
             Accessory quantity now follows
             wheelchair quantity.
             ================================================= */

          if (
            selectedAccessories.length >
            0
          ) {


            const accessoryItems =
              [];


            selectedAccessories.forEach(
              function (checkbox) {


                const variantId =
                  parseInt(
                    checkbox.value,
                    10
                  );


                if (variantId) {


                  accessoryItems.push({

                    id:
                      variantId,


                    /*
                      OPTION A

                      Same quantity as wheelchair.
                    */

                    quantity:
                      mainProductQuantity

                  });


                }

              }
            );



            if (
              accessoryItems.length >
              0
            ) {


              const accessoryResponse =
                await fetch(
                  routes.cart_add_url,
                  {

                    method:
                      'POST',


                    headers: {

                      'Content-Type':
                        'application/json',


                      'Accept':
                        'application/json',


                      'X-Requested-With':
                        'XMLHttpRequest'

                    },


                    body:
                      JSON.stringify({

                        items:
                          accessoryItems

                      })

                  }
                );



              const accessoryResult =
                await accessoryResponse
                  .json();



              if (
                !accessoryResponse.ok ||
                accessoryResult.status
              ) {


                throw new Error(

                  accessoryResult.description ||

                  accessoryResult.message ||

                  'Unable to add one or more selected accessories.'

                );

              }

            }

          }



          /* =================================================
             STEP 3
             ADD MAIN WHEELCHAIR

             Keep original Webibazaar / Storego method
             so existing cart notification continues
             to work properly.
             ================================================= */

          const config =
            fetchConfig(
              'javascript'
            );


          config.headers[
            'X-Requested-With'
          ] =
            'XMLHttpRequest';


          delete config.headers[
            'Content-Type'
          ];



          const formData =
            new FormData(
              this.form
            );



          /* =================================================
             SAFETY:
             ENSURE MAIN PRODUCT QUANTITY IS CORRECT
             ================================================= */

          formData.set(
            'quantity',
            mainProductQuantity
          );



          if (
            this.cartNotification
          ) {


            formData.append(
              'sections',

              this.cartNotification
                .getSectionsToRender()
                .map(
                  function (section) {

                    return section.id;

                  }
                )
            );


            formData.append(
              'sections_url',
              window.location.pathname
            );

          }



          config.body =
            formData;



          const mainResponse =
            await fetch(
              routes.cart_add_url,
              config
            );



          const response =
            await mainResponse
              .json();



          /* =================================================
             STEP 4
             HANDLE MAIN PRODUCT ERROR
             ================================================= */

          if (
            !mainResponse.ok ||
            response.status
          ) {


            const quickSuccess =
              this.querySelector(
                '.wbquicksuccess'
              );


            if (
              quickSuccess
            ) {

              quickSuccess.classList.add(
                'hidden'
              );

            }



            this.handleErrorMessage(

              response.description ||

              response.message ||

              'Unable to add this product to cart.'

            );


            return;

          }



          /* =================================================
             STEP 5
             EXISTING CART NOTIFICATION
             ================================================= */

          if (
            this.cartNotification
          ) {


            this.cartNotification
              .renderContents(
                response
              );

          }



          /* =================================================
             STEP 6
             SUCCESS MESSAGE
             ================================================= */

          const quickSuccess =
            this.querySelector(
              '.wbquicksuccess'
            );


          if (
            quickSuccess
          ) {

            quickSuccess.classList.remove(
              'hidden'
            );

          }



          /* =================================================
             STEP 7
             CLEAR ACCESSORY SELECTION
             AFTER SUCCESS
             ================================================= */

          if (
            accessoryRoot
          ) {


            accessoryRoot
              .querySelectorAll(
                '.meos-accessory__checkbox:checked'
              )
              .forEach(
                function (checkbox) {


                  checkbox.checked =
                    false;


                  checkbox.dispatchEvent(

                    new Event(
                      'change',
                      {
                        bubbles:
                          true
                      }
                    )

                  );

                }
              );

          }



        }

        catch (error) {


          console.error(
            'MEOS Add to Cart Error:',
            error
          );



          const quickSuccess =
            this.querySelector(
              '.wbquicksuccess'
            );


          if (
            quickSuccess
          ) {

            quickSuccess.classList.add(
              'hidden'
            );

          }



          this.handleErrorMessage(

            error.message ||

            'Something went wrong. Please try again.'

          );


        }

        finally {


          submitButton.classList.remove(
            'loading'
          );


          submitButton.removeAttribute(
            'aria-disabled'
          );


          if (
            spinner
          ) {

            spinner.classList.add(
              'hidden'
            );

          }

        }

      }



      /* =====================================================
         ERROR MESSAGE
         ===================================================== */

      handleErrorMessage(
        errorMessage = false
      ) {


        this.errorMessageWrapper =
          this.errorMessageWrapper ||

          this.querySelector(
            '.product-form__error-message-wrapper'
          );



        if (
          !this.errorMessageWrapper
        ) {

          return;

        }



        this.errorMessage =
          this.errorMessage ||

          this.errorMessageWrapper
            .querySelector(
              '.product-form__error-message'
            );



        this.errorMessageWrapper
          .toggleAttribute(
            'hidden',
            !errorMessage
          );



        if (
          errorMessage &&
          this.errorMessage
        ) {


          this.errorMessage.textContent =
            errorMessage;

        }

      }

    }

  );

}